import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";

import ic_delete from "../assets/images/ic_delete.svg";
import ic_edit from "../assets/images/ic_edit.svg";
import ic_eyes from "../assets/images/ic_eyes.svg";
import Modal from "react-bootstrap/Modal";
import { MDBRow, MDBCol } from "mdb-react-ui-kit";

import {
  DeleteCallWithErrorResponse,
  multipartPostCallWithErrorResponse,
  PostCallWithAuthTokenWithErrorResponse,
  putMultipartWithAuthCallWithErrorResponse,
  simpleGetCallWithErrorResponse,
} from "../api/ApiServices";
import ApiConfig, { FILE_BASE_URL } from "../api/ApiConfig";
import { ToastMsg } from "./TostMsg";
import { Pagination } from "./Pagination";
import FormLoader from "./FormLoader";
const Namaaz = ({ key }) => {

  let module_id;
  let course_yr_id;
  let category_id;

  if (typeof window !== undefined) {
    module_id = localStorage.getItem("module_id");
    course_yr_id = localStorage.getItem("course_yr_id");
    category_id = localStorage.getItem("category_id");
  }

  const { sidebar, adminData } = useContext(AppContext);
  const [loader, setLoader] = useState(true);
  const [lasatSabaqId, setLsatSabaq] = useState("");
  const [saveBotton, setSaveBotton] = useState(false);

  const [viewDetails, setViewDetails] = useState([]);
  const [imageWidth, setImageWidth] = useState({
    sabaqAudio: "100%",
    Uploade: "100%",
    tarjamaAudio: "100%",
    Description: "100%",
    subSabaqTitle: "100%",
    arabicAudio: "100%",
  });
  const [addNamaz, setAddNamaz] = useState({
    sabaqName: "",
    sabaqEnglish:"",
    sabaqHindi:"",
    sabaqUrdu:"",
    sabaqArabic:"",
    sabaqDesc: "",
    sabaqDescEnglish:"",
    sabaqDescHindi:"",
    sabaqDescUrdu:"",
    sabaqDescArabic:"",
    sabaqIcon: [],
    sabaqDescAudio: "",
    sabaqDescAudioEnglish:"",
    sabaqDescAudioArabic:"",
    sabaqNameAudio: "",
    sabaqNameAudioEnglish:"",
    sabaqNameAudioArabic:"",
    sabaqDescReference: "",
    sabaqDescReferenceEnglish:"",
    sabaqDescReferenceHindi:"",
    sabaqDescReferenceUrdu:"",
    sabaqDescReferenceArabic:"",
    sabaqTeacherAudio:'',
    sabaqNameTeacherAudioEnglish:'',
    sabaqNameTeacherAudioArabic:'',
    sabaqTeacherDesc:"",
    sabaqDescTeacherAudioEnglish:"",
    sabaqDescTeacherAudioArabic:"",
    subSabaq: [
      {
        subSabaqTitle: "",
        subSabaqTitleEnglish:"",
        subSabaqTitleHindi:"",
        subSabaqTitleUrdu:"",
        subSabaqTitleArabic:"",
        subSabaqDesc: "",
        subSabaqDescEnglish:"",
        subSabaqDescHindi:"",
        subSabaqDescUrdu:"",
        subSabaqDescArabic:"",
        subSabaqTitleAudio: "",
        subSabaqTitleAudioEnglish:"",
        subSabaqTitleAudioArabic:"",
        subSabaqDescAudio: "",
        subSabaqDescAudioEnglish:"",
        subSabaqDescAudioArabic:"",
        tarjamaAudioPath: "",
        tarjamaAudioPathEnglish:"",
        tarjamaAudioPathArabic:"",
        tarjama: "",
        tarjamaEnglish:"",
        tarjamaHindi:"",
        tarjamaUrdu:"",
        tarjamaArabic:"",
        subSabaqDescReference: "",
        subSabaqDescReferenceEnglsih:"",
        subSabaqDescReferenceHindi:"",
        subSabaqDescReferenceUrdu:"",
        subSabaqDescReferenceArabic:"",
        teacherTarjamaAudioPath:"",
        teacherTarjamaAudioPathEnglish:"",
        teacherTarjamaAudioPathArabic:"",
        titleTeacherAudioPath:"",
        subSabaqTitleTeacherAudioEnglish:"",
        subSabaqTitleTeacherAudioArabic:"",
        teacherDescAudioPath:"",
        subSabaqDescTeacherAudioEnglish:"",
        subSabaqDescTeacherAudioArabic:"",

      },
    ],
  });
  const [idEdit, setIdEdit] = useState("");

  const [add, setAdd] = useState(false);
  const handleAddClose = () => {
    setAdd(false)
    setIdEdit("");
    setAddNamaz({
      sabaqName: "",
      sabaqEnglish:"",
      sabaqHindi:"",
      sabaqUrdu:"",
      sabaqArabic:"",
      sabaqDesc: "",
      sabaqDescEnglish:"",
      sabaqDescHindi:"",
      sabaqDescUrdu:"",
      sabaqDescArabic:"",
      sabaqDescAudio: "",
      sabaqDescAudioEnglish:"",
      sabaqDescAudioArabic:"",
      sabaqIcon: [],
      sabaqNameAudio: "",
      sabaqNameAudioEnglish:"",
      sabaqNameAudioArabic:"",
      sabaqDescReference: "",
      sabaqDescReferenceEnglish:"",
      sabaqDescReferenceHindi:"",
      sabaqDescReferenceUrdu:"",
      sabaqDescReferenceArabic:"",
      sabaqTeacherAudio:'',
      sabaqNameTeacherAudioEnglish:'',
      sabaqNameTeacherAudioArabic:'',
      sabaqDescReference: "",
      sabaqDescReferenceEnglish:"",
      sabaqDescReferenceHindi:"",
      sabaqDescReferenceUrdu:"",
      sabaqDescReferenceArabic:"",

      subSabaq: [
        {
          subSabaqTitle: "",
          subSabaqTitleEnglish:"",
          subSabaqTitleHindi:"",
          subSabaqTitleUrdu:"",
          subSabaqTitleArabic:"",
          subSabaqDesc: "",
          subSabaqDescEnglish:"",
          subSabaqDescHindi:"",
          subSabaqDescUrdu:"",
          subSabaqDescArabic:"",
          subSabaqTitleAudio: "",
          subSabaqTitleAudioEnglish:"",
          subSabaqTitleAudioArabic:"",
          subSabaqDescAudio: "",
          subSabaqDescAudioEnglish:"",
          subSabaqDescAudioArabic:"",
          tarjamaAudioPath: "",
          tarjamaAudioPathEnglish:"",
          tarjamaAudioPathArabic:"",
          tarjama: "",
          tarjamaEnglish:"",
          tarjamaHindi:"",
          tarjamaUrdu:"",
          tarjamaArabic:"",
          subSabaqDescReference: "",
          subSabaqDescReferenceEnglsih:"",
          subSabaqDescReferenceHindi:"",
          subSabaqDescReferenceUrdu:"",
          subSabaqDescReferenceArabic:"",
          teacherTarjamaAudioPath:"",
          teacherTarjamaAudioPathEnglish:"",
          teacherTarjamaAudioPathArabic:"",
          titleTeacherAudioPath:"",
          subSabaqTitleTeacherAudioEnglish:"",
          subSabaqTitleTeacherAudioArabic:"",
          teacherDescAudioPath:"",
          subSabaqDescTeacherAudioEnglish:"",
          subSabaqDescTeacherAudioArabic:"",
        },
      ],
    });
    setAdd(false);
  };
  const handleAddShow = () => setAdd(true);
  const [deleteId, setDeleteId] = useState("");
  const [deleteModal, setDelete] = useState(false);
  const handleDeleteClose = () => setDelete(false);
  const handleDeleteShow = () => setDelete(true);

  const [viewModal, setView] = useState(false);
  const handleViewClose = () => setView(false);
  const handleViewShow = () => setView(true);

  const [validated, setValidated] = useState(false);
  const [namazList, setNamazList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const startIndex = currentPage * 15;
  const endIndex = startIndex + 15;
  const changePage = ({ selected }) => {
    setCurrentPage(selected);
  };
  const pageCount = Math.ceil(namazList?.length / 15);
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      addNamazqApi();
    }

    setValidated(true);
  };


  // add
  const addNamazqApi = () => {
    setSaveBotton(true);
    handleAddClose();
    setLoader(true);
    const body = {
      moduleId: module_id,
      courseYrId: (module_id === 1 || module_id === 2) && course_yr_id,
      categoryId: 7,
      userId: Number(adminData.user_id),
      sabaqNo: lasatSabaqId,
      sabaqName: addNamaz.sabaqName ? addNamaz.sabaqName : "",
      sabaqEnglish: addNamaz.sabaqEnglish ? addNamaz.sabaqEnglish : "",
      sabaqHindi: addNamaz.sabaqHindi ? addNamaz.sabaqHindi : "",
      sabaqUrdu: addNamaz.sabaqUrdu ? addNamaz.sabaqUrdu : "",
      sabaqArabic: addNamaz.sabaqArabic ? addNamaz.sabaqArabic : "",
      sabaqDesc: addNamaz.sabaqDesc ? addNamaz.sabaqDesc : "",
      sabaqDescEnglish: addNamaz.sabaqDescEnglish ? addNamaz.sabaqDescEnglish : "",
      sabaqDescHindi: addNamaz.sabaqDescHindi ? addNamaz.sabaqDescHindi : "",
      sabaqDescUrdu: addNamaz.sabaqDescUrdu ? addNamaz.sabaqDescUrdu : "",
      sabaqDescArabic: addNamaz.sabaqDescArabic ? addNamaz.sabaqDescArabic : "",
      sabaqDescReference: addNamaz.sabaqDescReference ? addNamaz.sabaqDescReference : "",
      sabaqDescReferenceEnglish: addNamaz.sabaqDescReferenceEnglish ? addNamaz.sabaqDescReferenceEnglish : "",
      sabaqDescReferenceHindi: addNamaz.sabaqDescReferenceHindi ? addNamaz.sabaqDescReferenceHindi : "",
      sabaqDescReferenceUrdu: addNamaz.sabaqDescReferenceUrdu ? addNamaz.sabaqDescReferenceUrdu : "",
      sabaqDescReferenceArabic: addNamaz.sabaqDescReferenceArabic ? addNamaz.sabaqDescReferenceArabic : "",
      sabaqId: addNamaz.SabaqId,
      sabaqIcon: addNamaz.sabaqIcon,
    };

    //all dataa paylodade

    let payLoadFormData = new FormData();
    payLoadFormData.append("moduleId", body.moduleId);
    payLoadFormData.append("courseYrId", course_yr_id);
    payLoadFormData.append("categoryId", body.categoryId);
    payLoadFormData.append("userId", body.userId);
    payLoadFormData.append("sabaqNo", body.sabaqNo);
    payLoadFormData.append("sabaqIcon", body.sabaqIcon ? body.sabaqIcon : "");
    payLoadFormData.append("sabaqName", body.sabaqName);
    payLoadFormData.append("sabaqEnglish", body.sabaqEnglish);
    payLoadFormData.append("sabaqHindi", body.sabaqHindi);
    payLoadFormData.append("sabaqUrdu", body.sabaqUrdu);
    payLoadFormData.append("sabaqArabic", body.sabaqArabic);
    payLoadFormData.append("sabaqDesc", body.sabaqDesc);
    payLoadFormData.append("sabaqDescEnglish", body.sabaqDescEnglish);
    payLoadFormData.append("sabaqDescHindi", body.sabaqDescHindi);
    payLoadFormData.append("sabaqDescUrdu", body.sabaqDescUrdu);
    payLoadFormData.append("sabaqDescArabic", body.sabaqDescArabic);
    payLoadFormData.append("sabaqDescReference", body.sabaqDescReference);
    payLoadFormData.append("sabaqDescReferenceEnglish", body.sabaqDescReferenceEnglish);
    payLoadFormData.append("sabaqDescReferenceHindi", body.sabaqDescReferenceHindi);
    payLoadFormData.append("sabaqDescReferenceUrdu", body.sabaqDescReferenceUrdu);
    payLoadFormData.append("sabaqDescReferenceArabic", body.sabaqDescReferenceArabic);
    payLoadFormData.append("sabaqId", body.sabaqId);
    let subSabaq = addNamaz.subSabaq.map((ele, index) => {
      return {
        subSabaqDescReference: ele.subSabaqDescReference ? ele.subSabaqDescReference : "",
        subSabaqDescReferenceEnglsih: ele.subSabaqDescReferenceEnglsih ? ele.subSabaqDescReferenceEnglsih : "",
        subSabaqDescReferenceHindi: ele.subSabaqDescReferenceHindi ? ele.subSabaqDescReferenceHindi : "",
        subSabaqDescReferenceUrdu: ele.subSabaqDescReferenceUrdu ? ele.subSabaqDescReferenceUrdu : "",
        subSabaqDescReferenceArabic: ele.subSabaqDescReferenceArabic ? ele.subSabaqDescReferenceArabic : "",
        subSabaqDesc: ele.subSabaqDesc ? ele.subSabaqDesc : "",
        subSabaqDescEnglish: ele.subSabaqDescEnglish ? ele.subSabaqDescEnglish : "",
        subSabaqDescHindi: ele.subSabaqDescHindi ? ele.subSabaqDescHindi : "",
        subSabaqDescUrdu: ele.subSabaqDescUrdu ? ele.subSabaqDescUrdu : "",
        subSabaqDescArabic: ele.subSabaqDescArabic ? ele.subSabaqDescArabic : "",
        subSabaqNo: index + 1,
        tarjama: ele.tarjama ? ele.tarjama : "",
        tarjamaEnglish: ele.tarjamaEnglish ? ele.tarjamaEnglish : "",
        tarjamaHindi: ele.tarjamaHindi ? ele.tarjamaHindi : "",
        tarjamaUrdu: ele.tarjamaUrdu ? ele.tarjamaUrdu : "",
        tarjamaArabic: ele.tarjamaArabic ? ele.tarjamaArabic : "",
        subSabaqTitle: ele.subSabaqTitle ? ele.subSabaqTitle : "",
        subSabaqTitleEnglish: ele.subSabaqTitleEnglish ? ele.subSabaqTitleEnglish : "",
        subSabaqTitleHindi: ele.subSabaqTitleHindi ? ele.subSabaqTitleHindi : "",
        subSabaqTitleUrdu: ele.subSabaqTitleUrdu ? ele.subSabaqTitleUrdu : "",
        subSabaqTitleArabic: ele.subSabaqTitleArabic ? ele.subSabaqTitleArabic : "",

        subSabaqDescReference: ele.subSabaqDescReference ? ele.subSabaqDescReference : "",
        subSabaqDescReferenceEnglsih: ele.subSabaqDescReferenceEnglsih ? ele.subSabaqDescReferenceEnglsih : "",
        subSabaqDescReferenceHindi: ele.subSabaqDescReferenceHindi ? ele.subSabaqDescReferenceHindi : "",
        subSabaqDescReferenceUrdu: ele.subSabaqDescReferenceUrdu ? ele.subSabaqDescReferenceUrdu : "",
        subSabaqDescReferenceArabic: ele.subSabaqDescReferenceArabic ? ele.subSabaqDescReferenceArabic : "",
        //  arabic: ele.arabic,
        subSabaqTitleAudio:
          ele.subSabaqTitleAudio == "" ? "no file" : "file name",

        subSabaqTitleAudioEnglish:
        ele.subSabaqTitleAudioEnglish == "" ? "no file" : "file name",

        subSabaqTitleAudioArabic:
        ele.subSabaqTitleAudioArabic == "" ? "no file" : "file name",

        subSabaqDescAudio:
        ele.subSabaqDescAudio == "" ? "no file" : "file name",

        subSabaqDescAudioEnglish:
        ele.subSabaqDescAudioEnglish == "" ? "no file" : "file name",
          
        subSabaqDescAudioArabic:
        ele.subSabaqDescAudioArabic == "" ? "no file" : "file name",

        tarjamaAudioPath:
        ele.tarjamaAudioPath == "" ? "no file" : "file name",

        tarjamaAudioPathEnglish:
        ele.tarjamaAudioPathEnglish == "" ? "no file" : "file name",

        tarjamaAudioPathArabic:
        ele.tarjamaAudioPathArabic == "" ? "no file" : "file name",
        //  arabicAudio:ele.arabicAudio=="" ?"no file":"file name",
        subSabaqTitleTeacherAudio:
        ele.titleTeacherAudioPath == "" ? "no file" : "file name",

        subSabaqTitleTeacherAudioEnglish:
        ele.subSabaqTitleTeacherAudioEnglish == "" ? "no file" : "file name",

        subSabaqTitleTeacherAudioArabic:
        ele.subSabaqTitleTeacherAudioArabic == "" ? "no file" : "file name",


        subSabaqDescTeacherAudio:
        ele.teacherDescAudioPath == "" ? "no file" : "file name",

        subSabaqDescTeacherAudioEnglish:
        ele.subSabaqDescTeacherAudioEnglish == "" ? "no file" : "file name",

        subSabaqDescTeacherAudioArabic:
        ele.subSabaqDescTeacherAudioArabic == "" ? "no file" : "file name",

        teacherTarjamaAudioPath:
        ele.teacherTarjamaAudioPath == "" ? "no file" : "file name",

        teacherTarjamaAudioPathEnglish:
       ele.teacherTarjamaAudioPathEnglish == "" ? "no file" : "file name",

        teacherTarjamaAudioPathArabic:
        ele.teacherTarjamaAudioPathArabic == "" ? "no file" : "file name",
      };
    });
    let subSabaqEdit = addNamaz.subSabaq.map((ele, index) => {
      return {
        subSabaqDescReference: ele.subSabaqDescReference ? ele.subSabaqDescReference : "",
        subSabaqDescReferenceEnglsih: ele.subSabaqDescReferenceEnglsih ? ele.subSabaqDescReferenceEnglsih : "",
        subSabaqDescReferenceHindi: ele.subSabaqDescReferenceHindi ? ele.subSabaqDescReferenceHindi : "",
        subSabaqDescReferenceUrdu: ele.subSabaqDescReferenceUrdu ? ele.subSabaqDescReferenceUrdu : "",
        subSabaqDescReferenceArabic: ele.subSabaqDescReferenceArabic ? ele.subSabaqDescReferenceArabic : "",

        subSabaqDesc: ele.subSabaqDesc ? ele.subSabaqDesc : "",
        subSabaqDescEnglish: ele.subSabaqDescEnglish ? ele.subSabaqDescEnglish : "",
        subSabaqDescHindi: ele.subSabaqDescHindi ? ele.subSabaqDescHindi : "",
        subSabaqDescUrdu: ele.subSabaqDescUrdu ? ele.subSabaqDescUrdu : "",
        subSabaqDescArabic: ele.subSabaqDescArabic ? ele.subSabaqDescArabic : "",
        subSabaqId: ele.subSabaqId,
        // subSabaqNo: ele.subSabaqNo,
        subSabaqNo: index + 1,

        tarjama: ele.tarjama ? ele.tarjama : "",
        tarjamaEnglish: ele.tarjamaEnglish ? ele.tarjamaEnglish : "",
        tarjamaHindi: ele.tarjamaHindi ? ele.tarjamaHindi : "",
        tarjamaUrdu: ele.tarjamaUrdu ? ele.tarjamaUrdu : "",
        tarjamaArabic: ele.tarjamaArabic ? ele.tarjamaArabic : "",
        subSabaqTitle: ele.subSabaqTitle ? ele.subSabaqTitle : "",
        subSabaqTitleEnglish: ele.subSabaqTitleEnglish ? ele.subSabaqTitleEnglish : "",
        subSabaqTitleHindi: ele.subSabaqTitleHindi ? ele.subSabaqTitleHindi : "",
        subSabaqTitleUrdu: ele.subSabaqTitleUrdu ? ele.subSabaqTitleUrdu : "",
        subSabaqTitleArabic: ele.subSabaqTitleArabic ? ele.subSabaqTitleArabic : "",
        //  arabic: ele.arabic,
        subSabaqTitleAudio:
          typeof ele.subSabaqTitleAudio == "object" ? "updated" : "not updated",
        
         subSabaqTitleAudioEnglish:
          typeof ele.subSabaqTitleAudioEnglish == "object" ? "updated" : "not updated",  

        subSabaqTitleAudioArabic:
          typeof ele.subSabaqTitleAudioArabic == "object" ? "updated" : "not updated",

        subSabaqDescAudio:
          typeof ele.subSabaqDescAudio == "object" ? "updated" : "not updated",
        
          subSabaqDescAudioEnglish:
          typeof ele.subSabaqDescAudioEnglish == "object" ? "updated" : "not updated",
          
           subSabaqDescAudioArabic:
          typeof ele.subSabaqDescAudioArabic == "object" ? "updated" : "not updated",
           
        tarjamaAudioPath:
          typeof ele.tarjamaAudioPath == "object"
            ? "updated"
            : "not updated",

        tarjamaAudioPathEnglish:
          typeof ele.tarjamaAudioPathEnglish == "object"
            ? "updated"
            : "not updated",
        tarjamaAudioPathArabic:
          typeof ele.tarjamaAudioPathArabic == "object"
            ? "updated"
            : "not updated",         
        //  arabicAudio:typeof(ele.arabicAudio)=="string" ? "not updated" : "updated",
        subSabaqTitleTeacherAudio:
        typeof ele.titleTeacherAudioPath == "object" ? "updated" : "not updated",

         subSabaqTitleTeacherAudioEnglish:
        typeof ele.subSabaqTitleTeacherAudioEnglish == "object" ? "updated" : "not updated",

         subSabaqTitleTeacherAudioArabic:
        typeof ele.subSabaqTitleTeacherAudioArabic == "object" ? "updated" : "not updated",

        subSabaqDescTeacherAudio:
        typeof ele.teacherDescAudioPath == "object" ? "updated" : "not updated",

         subSabaqDescTeacherAudioEnglish:
        typeof ele.subSabaqDescTeacherAudioEnglish == "object" ? "updated" : "not updated",

         subSabaqDescTeacherAudioArabic:
        typeof ele.subSabaqDescTeacherAudioArabic == "object" ? "updated" : "not updated",

        teacherTarjamaAudioPath:
        typeof ele.teacherTarjamaAudioPath == "object"
          ? "updated"
          : "not updated",

         teacherTarjamaAudioPathEnglish :
        typeof ele.teacherTarjamaAudioPathEnglish == "object"
          ? "updated"
          : "not updated",
          
         teacherTarjamaAudioPathArabic:
        typeof ele.teacherTarjamaAudioPathArabic == "object"
          ? "updated"
          : "not updated",  
      };
    });
    idEdit === "edit"
      ? payLoadFormData.append("subSabaq", JSON.stringify(subSabaqEdit))
      : payLoadFormData.append("subSabaq", JSON.stringify(subSabaq));

    let newSubaqAudio = [];
    newSubaqAudio.push(addNamaz.sabaqNameAudio);
    newSubaqAudio.map((ele) => payLoadFormData.append("sabaqNameAudio", ele ? ele : ""));
     let sabaqNameAudioEnglish = [];
    newSubaqAudio.push(addNamaz.sabaqNameAudioEnglish);
    newSubaqAudio.map((ele) => payLoadFormData.append("sabaqNameAudioEnglish", ele ? ele : ""));
     let sabaqNameAudioArabic = [];
    newSubaqAudio.push(addNamaz.sabaqNameAudioArabic);
    newSubaqAudio.map((ele) => payLoadFormData.append("sabaqNameAudioArabic", ele ? ele : ""));

    let newSubaqTeacherAudio = [];
    newSubaqTeacherAudio.push(addNamaz.sabaqTeacherAudio);
    newSubaqTeacherAudio.map((ele) => payLoadFormData.append("sabaqNameTeacherAudio", ele ? ele : ""));

     let sabaqNameTeacherAudioEnglish = [];
    sabaqNameTeacherAudioEnglish.push(addNamaz.sabaqNameTeacherAudioEnglish);
    sabaqNameTeacherAudioEnglish.map((ele) => payLoadFormData.append("sabaqNameTeacherAudioEnglish", ele ? ele : ""));

     let sabaqNameTeacherAudioArabic = [];
    sabaqNameTeacherAudioArabic.push(addNamaz.sabaqNameTeacherAudioArabic);
    sabaqNameTeacherAudioArabic.map((ele) => payLoadFormData.append("sabaqNameTeacherAudioArabic", ele ? ele : ""));

    let newSubaqTeacherDescAudio = [];
    newSubaqTeacherDescAudio.push(addNamaz.sabaqTeacherDesc);
    newSubaqTeacherDescAudio.map((ele) => payLoadFormData.append("sabaqDescTeacherAudio", ele ? ele : ""));

    let sabaqDescTeacherAudioEnglish = [];
    sabaqDescTeacherAudioEnglish.push(addNamaz.sabaqDescTeacherAudioEnglish);
    sabaqDescTeacherAudioEnglish.map((ele) => payLoadFormData.append("sabaqDescTeacherAudioEnglish", ele ? ele : ""));

    let sabaqDescTeacherAudioArabic = [];
    sabaqDescTeacherAudioArabic.push(addNamaz.sabaqDescTeacherAudioArabic);
    sabaqDescTeacherAudioArabic.map((ele) => payLoadFormData.append("sabaqDescTeacherAudioArabic", ele ? ele : ""));
    //
    let newSubaqAudio2 = [];
    newSubaqAudio2.push(addNamaz.sabaqDescAudio);
    newSubaqAudio2.map((ele) => payLoadFormData.append("sabaqDescAudio", ele ? ele : ""));

    let sabaqDescAudioEnglish = [];
    sabaqDescAudioEnglish.push(addNamaz.sabaqDescAudioEnglish);
    sabaqDescAudioEnglish.map((ele) => payLoadFormData.append("sabaqDescAudioEnglish", ele ? ele : ""));

    let sabaqDescAudioArabic = [];
    sabaqDescAudioArabic.push(addNamaz.sabaqDescAudioArabic);
    sabaqDescAudioArabic.map((ele) => payLoadFormData.append("sabaqDescAudioArabic", ele ? ele : ""));

    addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("subSabaqDescAudio", ele.subSabaqDescAudio ? ele.subSabaqDescAudio : "")
    );

     addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("subSabaqDescAudioEnglish", ele.subSabaqDescAudioEnglish ? ele.subSabaqDescAudioEnglish : "")
    );

     addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("subSabaqDescAudioArabic", ele.subSabaqDescAudioArabic ? ele.subSabaqDescAudioArabic : "")
    );

    addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("tarjamaAudioPath", ele.tarjamaAudioPath ? ele.tarjamaAudioPath : "")
    );

     addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("tarjamaAudioPathEnglish", ele.tarjamaAudioPathEnglish ? ele.tarjamaAudioPathEnglish : "")
    );

     addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("tarjamaAudioPathArabic", ele.tarjamaAudioPathArabic ? ele.tarjamaAudioPathArabic : "")
    );
    addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("subSabaqTitleAudio", ele.subSabaqTitleAudio ? ele.subSabaqTitleAudio : "")
    );

     addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("subSabaqTitleAudioEnglish", ele.subSabaqTitleAudioEnglish ? ele.subSabaqTitleAudioEnglish : "")
    );

     addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("subSabaqTitleAudioArabic", ele.subSabaqTitleAudioArabic ? ele.subSabaqTitleAudioArabic : "")
    );

    addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("subSabaqTitleTeacherAudio", ele.titleTeacherAudioPath ? ele.titleTeacherAudioPath : "")
    );
    addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("subSabaqTitleTeacherAudioEnglish", ele.subSabaqTitleTeacherAudioEnglish ? ele.subSabaqTitleTeacherAudioEnglish : "")
    );
    addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("subSabaqTitleTeacherAudioArabic", ele.subSabaqTitleTeacherAudioArabic ? ele.subSabaqTitleTeacherAudioArabic : "")
    );

    addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("subSabaqDescTeacherAudio", ele.teacherDescAudioPath ? ele.teacherDescAudioPath : "")
    );

     addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("subSabaqDescTeacherAudioEnglish", ele.subSabaqDescTeacherAudioEnglish ? ele.subSabaqDescTeacherAudioEnglish : "")
    );

     addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("subSabaqDescTeacherAudioArabic", ele.subSabaqDescTeacherAudioArabic ? ele.subSabaqDescTeacherAudioArabic : "")
    );

    addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("teacherTarjamaAudioPath", ele.teacherTarjamaAudioPath ? ele.teacherTarjamaAudioPath : "")
    );
    
     addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("teacherTarjamaAudioPathEnglish", ele.teacherTarjamaAudioPathEnglish ? ele.teacherTarjamaAudioPathEnglish : "")
    );

     addNamaz.subSabaq.map((ele) =>
      payLoadFormData.append("teacherTarjamaAudioPathArabic", ele.teacherTarjamaAudioPathArabic ? ele.teacherTarjamaAudioPathArabic : "")
    );
    // addNamaz.subSabaq.map((ele) =>
    //   payLoadFormData.append(
    //     "arabicAudio",
    //     ele.arabicAudio
    //   )
    // );

    // setIsLoading(true);
    idEdit === "edit"
      ? putMultipartWithAuthCallWithErrorResponse(
        ApiConfig.UPDATE_SABAQ_SECTION,
        payLoadFormData
      )
        .then((res) => {
          if (res.json && res.json?.success === true) {
            ToastMsg("success", res.json.message);
            namazListApi();
            setSaveBotton(false);
          } else {
            ToastMsg("error", res.json.message);
          }
        })
        .catch((err) => {
          setLoader(false);

          ToastMsg("error", "something went wrong");
        })
      : multipartPostCallWithErrorResponse(
        ApiConfig.ADD_SABAQ_SECTION,
        payLoadFormData
        // payLoadFormDataNew
      )
        .then((res) => {
          if (res.json && res.json?.success === true) {
            ToastMsg("success", res.json.message);
            namazListApi();
            setSaveBotton(false);
          } else {
            ToastMsg("error", res.json.message);
          }
        })
        .catch((err) => {
          setLoader(false);

          ToastMsg("error", "something went wrong");
        });
  };

  //
  useEffect(() => {
    namazListApi();
  }, [key]);
  const namazListApi = () => {
    const apiUrl = (module_id == 1 || module_id == 2)
      ? ApiConfig.GET_ALL_SABAQ + `moduleId=${module_id}&courseYrId=${course_yr_id}&categoryId=${7}`
      : ApiConfig.GET_ALL_SABAQ + `moduleId=${module_id}&categoryId=${7}`;
    // setIsLoading(true);

    simpleGetCallWithErrorResponse(apiUrl)
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          setNamazList(res.json.data?.allSabaq);
          setLsatSabaq(res.json?.data.allSabaq.length);
          // pagination();
          // ToastMsg("success", res.json.message);
        } else {
          // ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };

  const namazLisDeleteApi = () => {
    const body = {
      categoryId: 7,

      sabaqId: deleteId,
    };
    // setIsLoading(true);
    DeleteCallWithErrorResponse(
      ApiConfig.DELETE_SABAQ_SECION,

      JSON.stringify({
        ...body,
      })
    )
      .then((res) => {
        setLoader(false);
        if (res.json && res.json?.success === true) {
          // setSabaqList(res.json.data);
          namazListApi();
          handleDeleteClose();
          ToastMsg("success", res.json.message);
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };
  //
  const EditListApi = (id) => {
    // setIsLoading(true);

    simpleGetCallWithErrorResponse(ApiConfig.VIEW_SABAQ_SECTION + `sabaqId=${id}&categoryId=${category_id}`)
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          // ToastMsg("success", res.json.message);
          let data = res.json?.data;
          setAddNamaz({
            SabaqId: data?.SabaqId,
            sabaqName: data?.sabaqName,
            sabaqEnglish: data?.sabaqEnglish,
            sabaqHindi: data?.sabaqHindi,
            sabaqUrdu: data?.sabaqUrdu,
            sabaqArabic: data?.sabaqArabic,
            sabaqDesc: data?.sabaqDesc,
            sabaqDescEnglish: data?.sabaqDescEnglish,
            sabaqDescHindi: data?.sabaqDescHindi,
            sabaqDescUrdu: data?.sabaqDescUrdu,
            sabaqDescArabic: data?.sabaqDescArabic,
            sabaqDescAudio: data?.sabaqDescAudio,
            sabaqDescAudioEnglish: data?.sabaqDescAudioEnglish,
            sabaqDescAudioArabic: data?.sabaqDescAudioArabic,
            sabaqIcon: data?.sabaqIcon,
            sabaqNameAudio: data?.sabaqAudio,
            sabaqNameAudioEnglish: data?.sabaqNameAudioEnglish,
            sabaqNameAudioArabic: data?.sabaqNameAudioEnglish,
            sabaqDescReference: data?.sabaqDescReference,
            sabaqDescReferenceEnglish: data?.sabaqDescReferenceEnglish,
            sabaqDescReferenceHindi: data?.sabaqDescReferenceHindi,
            sabaqDescReferenceUrdu: data?.sabaqDescReferenceUrdu,
            sabaqDescReferenceArabic: data?.sabaqDescReferenceArabic,
            sabaqTeacherAudio:data?.sabaqTeacherAudio,
            sabaqNameTeacherAudioEnglish:data?.sabaqNameTeacherAudioEnglish,
            sabaqNameTeacherAudioArabic:data?.sabaqNameTeacherAudioArabic,
            sabaqTeacherDesc:data?.sabaqTeacherDesc,
            sabaqDescTeacherAudioEnglish:data?.sabaqDescTeacherAudioEnglish,
            sabaqDescTeacherAudioArabic:data?.sabaqDescTeacherAudioArabic,
            
            subSabaq:
              data &&
              data.subSabaqs.map((ele) => {
                return {
                  subSabaqTitle: ele.subSabaqTitle,
                  subSabaqTitleEnglish: ele.subSabaqTitleEnglish,
                  subSabaqTitleHindi: ele.subSabaqTitleHindi,
                  subSabaqTitleUrdu: ele.subSabaqTitleUrdu,
                  subSabaqTitleArabic: ele.subSabaqTitleArabic,
                  subSabaqTitleAudio: ele.titleAudioPath,
                  subSabaqTitleAudioEnglish: ele.subSabaqTitleAudioEnglish,
                  subSabaqTitleAudioArabic: ele.subSabaqTitleAudioArabic,
                  subSabaqDesc: ele.subSabaqDesc,
                  subSabaqDescEnglish: ele.subSabaqDescEnglish,
                  subSabaqDescHindi: ele.subSabaqDescHindi,
                  subSabaqDescUrdu: ele.subSabaqDescUrdu,
                  subSabaqDescArabic: ele.subSabaqDescArabic,
                  subSabaqDescAudio: ele.descAudioPath,
                  subSabaqDescAudioEnglish: ele.subSabaqDescAudioEnglish,
                  subSabaqDescAudioArabic: ele.subSabaqDescAudioArabic,
                  tarjama: ele.tarjama,
                  tarjamaEnglish: ele.tarjamaEnglish,
                  tarjamaHindi: ele.tarjamaHindi,
                  tarjamaUrdu: ele.tarjamaUrdu,
                  tarjamaArabic: ele.tarjamaArabic,
                  tarjamaAudioPath: ele.tarjamaAudioPath,
                  tarjamaAudioPathEnglish: ele.tarjamaAudioPathEnglish,
                  tarjamaAudioPathArabic: ele.tarjamaAudioPathArabic,
                  subSabaqDescReference: ele.subSabaqDescReference,
                  subSabaqDescReferenceEnglsih: ele.subSabaqDescReferenceEnglsih,
                  subSabaqDescReferenceHindi: ele.subSabaqDescReferenceHindi,
                  subSabaqDescReferenceUrdu: ele.subSabaqDescReferenceUrdu,
                  subSabaqDescReferenceArabic: ele.subSabaqDescReferenceArabic,
                  subSabaqId: ele.subSabaqId,
                  subSabaqNo: ele.subSabaqNo,
                  titleTeacherAudioPath:ele.titleTeacherAudioPath,
                  subSabaqTitleTeacherAudioEnglish:ele.subSabaqTitleTeacherAudioEnglish,
                  subSabaqTitleTeacherAudioArabic:ele.subSabaqTitleTeacherAudioArabic,
                  teacherDescAudioPath:ele.teacherDescAudioPath,
                  subSabaqDescTeacherAudioEnglish:ele.subSabaqDescTeacherAudioEnglish,
                  subSabaqDescTeacherAudioArabic:ele.subSabaqDescTeacherAudioArabic,
                  teacherTarjamaAudioPath:ele.teacherTarjamaAudioPath,
                  teacherTarjamaAudioPathEnglish:ele.teacherTarjamaAudioPathEnglish,
                  teacherTarjamaAudioPathArabic:ele.teacherTarjamaAudioPathArabic,
                  
                };
              }),
          });
          handleAddShow();
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };

  //view the
  const viewDetailshandle = (id) => {
    simpleGetCallWithErrorResponse(ApiConfig.VIEW_SABAQ_SECTION + `sabaqId=${id}&categoryId=${category_id}`)
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          setViewDetails(res.json.data);
          handleViewShow();
          // ToastMsg("success", res.json.message);
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };

  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="heading-btn-main">
        <div className="heading-common">
          <label htmlFor="">Namaaz</label>
        </div>
        <div className="add-btn">
          <button onClick={handleAddShow}>
            Add Namaz
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path fill="white" d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z" />
            </svg>
          </button>
        </div>
      </div>
      {/* ======================= START ADD ========================== */}
      <Modal
        show={add}
        onHide={() => handleAddClose()}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton onHide={handleAddClose}>
          {/* <Modal.Title>Add Namaaz</Modal.Title> */}
          <Modal.Title>
            {idEdit === "edit" ? "Update  Namaaz" : "Add Namaz"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated} className="fw-bold" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Name</Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={addNamaz?.sabaqName}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqName: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
               <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Name(English)</Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={addNamaz?.sabaqEnglish}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqEnglish: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
               <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Name(Hindi)</Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={addNamaz?.sabaqHindi}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqHindi: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
               <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Name(Urdu)</Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={addNamaz?.sabaqUrdu}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqUrdu: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
               <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Name(Arabic)</Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={addNamaz?.sabaqArabic}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqArabic: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>


              {idEdit ? (
                <>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher And Student)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqNameAudio === "string"
                          ? addNamaz?.sabaqNameAudio.substring(
                            addNamaz?.sabaqNameAudio.length - 15,
                            addNamaz?.sabaqNameAudio.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqNameAudio: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher And Student)(English)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqNameAudioEnglish === "string"
                          ? addNamaz?.sabaqNameAudioEnglish.substring(
                            addNamaz?.sabaqNameAudioEnglish.length - 15,
                            addNamaz?.sabaqNameAudioEnglish.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqNameAudioEnglish: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher And Student)(Arabic)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqNameAudioArabic === "string"
                          ? addNamaz?.sabaqNameAudioArabic.substring(
                            addNamaz?.sabaqNameAudioArabic.length - 15,
                            addNamaz?.sabaqNameAudioArabic.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqNameAudioArabic: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                </>
              ) : (
                <>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher And Student)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqNameAudio: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher And Student)(English)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqNameAudioEnglish: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher And Student)(Arabic)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqNameAudioArabic: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                </>
              )}

              {idEdit ? (
                <>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher )
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqTeacherAudio === "string"
                          ? addNamaz?.sabaqTeacherAudio.substring(
                            addNamaz?.sabaqTeacherAudio.length - 15,
                            addNamaz?.sabaqTeacherAudio.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqTeacherAudio: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                   <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher )(English)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqNameTeacherAudioEnglish === "string"
                          ? addNamaz?.sabaqNameTeacherAudioEnglish.substring(
                            addNamaz?.sabaqNameTeacherAudioEnglish.length - 15,
                            addNamaz?.sabaqNameTeacherAudioEnglish.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqNameTeacherAudioEnglish: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                   <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio(Teacher )(Arabic)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqNameTeacherAudioArabic === "string"
                          ? addNamaz?.sabaqNameTeacherAudioArabic.substring(
                            addNamaz?.sabaqNameTeacherAudioArabic.length - 15,
                            addNamaz?.sabaqNameTeacherAudioArabic.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqNameTeacherAudioArabic: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                </>
              ) : (
                <>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher )</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqTeacherAudio: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                  <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher )(English)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqNameTeacherAudioEnglish: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                  <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio(Teacher )(Arabic)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqNameTeacherAudioArabic: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                </>
              )}
              {/* sabaqIcon */}
              {/*{idEdit ? (
                <div>
                  <MDBRow>
                    <MDBCol lg="1" md="1" className="mb-4">
                      <img
                        src={
                          !addNamaz?.sabaqIcon
                            ? ""
                            : ApiConfig.FILE_BASE_URL + addNamaz?.sabaqIcon.length
                              ? ApiConfig.FILE_BASE_URL + addNamaz?.sabaqIcon
                              : ApiConfig.FILE_BASE_URL + addNamaz?.sabaqIcon &&
                              URL.createObjectURL(ApiConfig.FILE_BASE_URL + addNamaz?.sabaqIcon)

                        }
                        className="img-fluid rounded value"
                        alt=""
                      />
                    </MDBCol>
                  </MDBRow>
                  <div className="col-md-12 mb-3">
                      <Form.Label>Update Sabaq Icon</Form.Label>
                      <Form.Control
                        type="file"
                        accept="image/*"
                        name="updateSabaqIcon"
                        onChange={(e) => {
                          setAddNamaz({
                            ...addNamaz,
                            sabaqIcon: e.target.files[0],
                          });
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Icon
                      </Form.Control.Feedback>
                    </div>
                </div>
              ) : (
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Icon</Form.Label>
                  <Form.Control
                    // required
                    type="file"
                    // accept="audio/mp3,audio/*;capture=microphone"
                    accept="image/*"
                    name="sabaqAudio"
                    src={addNamaz?.sabaqIcon}
                    //  / value={addNamaz?.sabaqAudio}
                    onChange={(e) => {
                      setAddNamaz({
                        ...addNamaz,
                        sabaqIcon: e.target.files[0],
                      });
                    }}
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Icon
                  </Form.Control.Feedback>
                </div>
              )}*/}


              <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={addNamaz?.sabaqDesc}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqDesc: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
               <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Description(English)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={addNamaz?.sabaqDescEnglish}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqDescEnglish: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
                <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Description(Hindi)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={addNamaz?.sabaqDescHindi}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqDescHindi: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
                <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Description(Urdu)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={addNamaz?.sabaqDescUrdu}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqDescUrdu: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
                <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Description(Arabic)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={addNamaz?.sabaqDescArabic}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, sabaqDescArabic: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>


              {idEdit ? (
                <>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher And Student)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqDescAudio === "string"
                          ? addNamaz?.sabaqDescAudio.substring(
                            addNamaz?.sabaqDescAudio.length - 15,
                            addNamaz?.sabaqDescAudio.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqDescAudio"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqDescAudio: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher And Student)(English)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqDescAudioEnglish === "string"
                          ? addNamaz?.sabaqDescAudioEnglish.substring(
                            addNamaz?.sabaqDescAudioEnglish.length - 15,
                            addNamaz?.sabaqDescAudioEnglish.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqDescAudio"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqDescAudioEnglish: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                                    <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher And Student)(Arabic)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqDescAudioArabic === "string"
                          ? addNamaz?.sabaqDescAudioArabic.substring(
                            addNamaz?.sabaqDescAudioArabic.length - 15,
                            addNamaz?.sabaqDescAudioArabic.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqDescAudio"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqDescAudioArabic: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                </>
              ) : (
                <>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher And Student)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImagePath"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqDescAudio: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher And Student)(English)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImagePath"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqDescAudioEnglish: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher And Student)(Arabic)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImagePath"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqDescAudioArabic: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                </>
              )}
                 {idEdit ? (
                <>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqTeacherDesc === "string"
                          ? addNamaz?.sabaqTeacherDesc.substring(
                            addNamaz?.sabaqTeacherDesc.length - 15,
                            addNamaz?.sabaqTeacherDesc.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqDescAudio"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqTeacherDesc: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                   <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher)(English)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqDescTeacherAudioEnglish === "string"
                          ? addNamaz?.sabaqDescTeacherAudioEnglish.substring(
                            addNamaz?.sabaqDescTeacherAudioEnglish.length - 15,
                            addNamaz?.sabaqDescTeacherAudioEnglish.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqDescAudio"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqDescTeacherAudioEnglish: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                   <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio(Teacher)(Arabic)
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.sabaqDescTeacherAudioArabic === "string"
                          ? addNamaz?.sabaqDescTeacherAudioArabic.substring(
                            addNamaz?.sabaqDescTeacherAudioArabic.length - 15,
                            addNamaz?.sabaqDescTeacherAudioArabic.length
                          )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqDescAudio"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            sabaqDescTeacherAudioArabic: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                </>
              ) : (
                <>
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImagePath"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqTeacherDesc: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                  <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher)(English)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImagePath"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqDescTeacherAudioEnglish: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                  <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Description Audio(Teacher)(Arabic)</Form.Label>
                  <Form.Control
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImagePath"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        sabaqDescTeacherAudioArabic: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
                </>
              )}

              <div className="col-md-12 mb-3">
                <Form.Label> Sabaq Reference</Form.Label>
                <Form.Control
                  type="text"
                  value={addNamaz?.sabaqDescReference}
                  onChange={(e) =>
                    setAddNamaz({
                      ...addNamaz,
                      sabaqDescReference: e.target.value,
                    })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Reference
                </Form.Control.Feedback>
              </div>
              
              
              <div className="col-md-12 mb-3">
                <Form.Label> Sabaq Reference(English)</Form.Label>
                <Form.Control
                  type="text"
                  value={addNamaz?.sabaqDescReferenceEnglish}
                  onChange={(e) =>
                    setAddNamaz({
                      ...addNamaz,
                      sabaqDescReferenceEnglish: e.target.value,
                    })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Reference
                </Form.Control.Feedback>
              </div>

              
              <div className="col-md-12 mb-3">
                <Form.Label> Sabaq Reference(Hindi)</Form.Label>
                <Form.Control
                  type="text"
                  value={addNamaz?.sabaqDescReferenceHindi}
                  onChange={(e) =>
                    setAddNamaz({
                      ...addNamaz,
                      sabaqDescReferenceHindi: e.target.value,
                    })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Reference
                </Form.Control.Feedback>
              </div>

              
              <div className="col-md-12 mb-3">
                <Form.Label> Sabaq Reference(Urdu)</Form.Label>
                <Form.Control
                  type="text"
                  value={addNamaz?.sabaqDescReferenceUrdu}
                  onChange={(e) =>
                    setAddNamaz({
                      ...addNamaz,
                      sabaqDescReferenceUrdu: e.target.value,
                    })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Reference
                </Form.Control.Feedback>
              </div>

              
              <div className="col-md-12 mb-3">
                <Form.Label> Sabaq Reference(Arabic)</Form.Label>
                <Form.Control
                  type="text"
                  value={addNamaz?.sabaqDescReferenceArabic}
                  onChange={(e) =>
                    setAddNamaz({
                      ...addNamaz,
                      sabaqDescReferenceArabic: e.target.value,
                    })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Reference
                </Form.Control.Feedback>
              </div>

              {addNamaz.subSabaq &&
                addNamaz.subSabaq.map((elementInArray, index) => {
                  return (
                    <div
                      className="col-md-12 sub-group-main"
                      key={"string" + index}
                    >
                      <div className="row">
                        <h6 className="fw-bold">Sub Sabaq Details</h6>
                        <div className="col-md-12 mb-3">
                          <Form.Label>
                            Sub Sabaq Title <span>{index + 1}</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqTitle}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqTitle: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sabaq Name
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>
                            Sub Sabaq Title(English)<span>{index + 1}</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqTitleEnglish}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqTitleEnglish: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sabaq Name
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>
                            Sub Sabaq Title(Hindi)<span>{index + 1}</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqTitleHindi}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqTitleHindi: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sabaq Name
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>
                            Sub Sabaq Title(Urdu)<span>{index + 1}</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqTitleUrdu}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqTitleUrdu: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sabaq Name
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>
                            Sub Sabaq Title(Arabic)<span>{index + 1}</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqTitleArabic}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqTitleArabic: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sabaq Name
                          </Form.Control.Feedback>
                        </div>

                        {idEdit ? (
                          <>
                            <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher And Student )
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.subSabaqTitleAudio ===
                                    "string"
                                    ? elementInArray?.subSabaqTitleAudio.substring(
                                      elementInArray?.subSabaqTitleAudio
                                        .length - 15,
                                      elementInArray?.subSabaqTitleAudio
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.subSabaqTitle }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              subSabaqTitleAudio:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                             <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher And Student )(English)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.subSabaqTitleAudioEnglish ===
                                    "string"
                                    ? elementInArray?.subSabaqTitleAudioEnglish.substring(
                                      elementInArray?.subSabaqTitleAudioEnglish
                                        .length - 15,
                                      elementInArray?.subSabaqTitleAudioEnglish
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.subSabaqTitle }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              subSabaqTitleAudioEnglish:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                             <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher And Student )(Arabic)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.subSabaqTitleAudioArabic ===
                                    "string"
                                    ? elementInArray?.subSabaqTitleAudioArabic.substring(
                                      elementInArray?.subSabaqTitleAudioArabic
                                        .length - 15,
                                      elementInArray?.subSabaqTitleAudioArabic
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.subSabaqTitle }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              subSabaqTitleAudioArabic:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                          <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Title Audio(Teacher And Student )</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          subSabaqTitleAudio:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                            <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Title Audio(Teacher And Student )(English)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          subSabaqTitleAudioEnglish:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                            <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Title Audio(Teacher And Student )(Arabic)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          subSabaqTitleAudioArabic:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                          </>
                        )}

{idEdit ? (
                          <>
                            <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher )
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.titleTeacherAudioPath ===
                                    "string"
                                    ? elementInArray?.titleTeacherAudioPath.substring(
                                      elementInArray?.titleTeacherAudioPath
                                        .length - 15,
                                      elementInArray?.titleTeacherAudioPath
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.subSabaqTitle }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              titleTeacherAudioPath:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                            <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher )(English)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.subSabaqTitleTeacherAudioEnglish ===
                                    "string"
                                    ? elementInArray?.subSabaqTitleTeacherAudioEnglish.substring(
                                      elementInArray?.subSabaqTitleTeacherAudioEnglish
                                        .length - 15,
                                      elementInArray?.subSabaqTitleTeacherAudioEnglish
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.subSabaqTitle }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              subSabaqTitleTeacherAudioEnglish:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                            <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio(Teacher )(Arabic)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.subSabaqTitleTeacherAudioArabic ===
                                    "string"
                                    ? elementInArray?.subSabaqTitleTeacherAudioArabic.substring(
                                      elementInArray?.subSabaqTitleTeacherAudioArabic
                                        .length - 15,
                                      elementInArray?.subSabaqTitleTeacherAudioArabic
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.subSabaqTitle }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              subSabaqTitleTeacherAudioArabic:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                          <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Title Audio(Teacher )</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          titleTeacherAudioPath:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                          <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Title Audio(Teacher )(English)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          subSabaqTitleTeacherAudioEnglish:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                          <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Title Audio(Teacher )(Arabic)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          subSabaqTitleTeacherAudioArabic:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                          </>
                        )}
                        <div className="col-md-12 mb-3">
                          <Form.Label> Sub Sabaq Reference</Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqDescReference}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescReference: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Reference
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label> Sub Sabaq Reference(English)</Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqDescReferenceEnglsih}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescReferenceEnglsih: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Reference
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label> Sub Sabaq Reference(Hindi)</Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqDescReferenceHindi}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescReferenceHindi: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Reference
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label> Sub Sabaq Reference(Urdu)</Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqDescReferenceUrdu}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescReferenceUrdu: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Reference
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label> Sub Sabaq Reference(Arabic)</Form.Label>
                          <Form.Control
                            type="text"
                            value={elementInArray?.subSabaqDescReferenceArabic}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescReferenceArabic: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Reference
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Tarjama</Form.Label>
                          <Form.Control
                            // required
                            type="text"
                            value={elementInArray?.tarjama}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (elementInArray, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                          ...elementInArray,
                                          tarjama: e.target.value,
                                        }
                                      : elementInArray;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Choose Sub Sabaq Tarjama
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Tarjama(English)</Form.Label>
                          <Form.Control
                            // required
                            type="text"
                            value={elementInArray?.tarjamaEnglish}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (elementInArray, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                          ...elementInArray,
                                          tarjamaEnglish: e.target.value,
                                        }
                                      : elementInArray;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Choose Sub Sabaq Tarjama
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Tarjama(Hindi)</Form.Label>
                          <Form.Control
                            // required
                            type="text"
                            value={elementInArray?.tarjamaHindi}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (elementInArray, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                          ...elementInArray,
                                          tarjamaHindi: e.target.value,
                                        }
                                      : elementInArray;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Choose Sub Sabaq Tarjama
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Tarjama(Urdu)</Form.Label>
                          <Form.Control
                            // required
                            type="text"
                            value={elementInArray?.tarjamaUrdu}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (elementInArray, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                          ...elementInArray,
                                          tarjamaUrdu: e.target.value,
                                        }
                                      : elementInArray;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Choose Sub Sabaq Tarjama
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Tarjama(Arabic)</Form.Label>
                          <Form.Control
                            // required
                            type="text"
                            value={elementInArray?.tarjamaArabic}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (elementInArray, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                          ...elementInArray,
                                          tarjamaArabic: e.target.value,
                                        }
                                      : elementInArray;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Choose Sub Sabaq Tarjama
                          </Form.Control.Feedback>
                        </div>
                        

                        {idEdit ? (
                          <>
                            <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Tarjama Audio(Teacher And Student)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.tarjamaAudioPath ===
                                    "string"
                                    ? elementInArray?.tarjamaAudioPath.substring(
                                      elementInArray?.tarjamaAudioPath
                                        .length - 15,
                                      elementInArray?.tarjamaAudioPath
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.tarjamaAudio }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      tarjamaAudio: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              tarjamaAudioPath:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                            <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Tarjama Audio(Teacher And Student)(English)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.tarjamaAudioPathEnglish ===
                                    "string"
                                    ? elementInArray?.tarjamaAudioPathEnglish.substring(
                                      elementInArray?.tarjamaAudioPathEnglish
                                        .length - 15,
                                      elementInArray?.tarjamaAudioPathEnglish
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.tarjamaAudio }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      tarjamaAudio: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              tarjamaAudioPathEnglish:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                            <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Tarjama Audio(Teacher And Student)(Arabic)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.tarjamaAudioPathArabic ===
                                    "string"
                                    ? elementInArray?.tarjamaAudioPathArabic.substring(
                                      elementInArray?.tarjamaAudioPathArabic
                                        .length - 15,
                                      elementInArray?.tarjamaAudioPathArabic
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.tarjamaAudio }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      tarjamaAudio: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              tarjamaAudioPathArabic:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                          <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Tarjama Audio(Teacher And Student)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          tarjamaAudioPath:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                             <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Tarjama Audio(Teacher And Student)(English)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          tarjamaAudioPathEnglish:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                             <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Tarjama Audio(Teacher And Student)(Arabic)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          tarjamaAudioPathArabic:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                          </>
                        )}
                                 
                      {idEdit ? (
                          <>
                            <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Tarjama Audio(Teacher)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.teacherTarjamaAudioPath ===
                                    "string"
                                    ? elementInArray?.teacherTarjamaAudioPath.substring(
                                      elementInArray?.teacherTarjamaAudioPath
                                        .length - 15,
                                      elementInArray?.teacherTarjamaAudioPath
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.tarjamaAudio }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      tarjamaAudio: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              teacherTarjamaAudioPath:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                              <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Tarjama Audio(Teacher)(English)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.teacherTarjamaAudioPathEnglish ===
                                    "string"
                                    ? elementInArray?.teacherTarjamaAudioPathEnglish.substring(
                                      elementInArray?.teacherTarjamaAudioPathEnglish
                                        .length - 15,
                                      elementInArray?.teacherTarjamaAudioPathEnglish
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.tarjamaAudio }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      tarjamaAudio: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              teacherTarjamaAudioPathEnglish:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                              <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Tarjama Audio(Teacher)(Arabic)
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.teacherTarjamaAudioPathArabic ===
                                    "string"
                                    ? elementInArray?.teacherTarjamaAudioPathArabic.substring(
                                      elementInArray?.teacherTarjamaAudioPathArabic
                                        .length - 15,
                                      elementInArray?.teacherTarjamaAudioPathArabic
                                        .length
                                    )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.tarjamaAudio }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      tarjamaAudio: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      subSabaq: addNamaz.subSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                              ...item,
                                              teacherTarjamaAudioPathArabic:
                                                e.target.files[0],
                                            }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                          <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Tarjama Audio(Teacher)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          teacherTarjamaAudioPath:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                             <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Tarjama Audio(Teacher)(English)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          teacherTarjamaAudioPathEnglish:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                             <div className="col-md-12 mb-3">
                            <Form.Label> Sub Sabaq Tarjama Audio(Teacher)(Arabic)</Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  subSabaq: addNamaz.subSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                          ...item,
                                          teacherTarjamaAudioPathArabic:
                                            e.target.files[0],
                                        }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                          </>
                        )}
                        <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={elementInArray?.subSabaqDesc}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDesc: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Aqaaid Description.
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Description(English)</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={elementInArray?.subSabaqDescEnglish}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescEnglish: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Aqaaid Description.
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Description(Hindi)</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={elementInArray?.subSabaqDescHindi}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescHindi: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Aqaaid Description.
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Description(Urdu)</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={elementInArray?.subSabaqDescUrdu}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescUrdu: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Aqaaid Description.
                          </Form.Control.Feedback>
                        </div>
                         <div className="col-md-12 mb-3">
                          <Form.Label>Sub Sabaq Description(Arabic)</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={elementInArray?.subSabaqDescArabic}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: addNamaz.subSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                        ...item,
                                        subSabaqDescArabic: e.target.value,
                                      }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Aqaaid Description.
                          </Form.Control.Feedback>
                        </div>
                        <>
                          {idEdit ? (
                            <>
                              <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher And Student)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.subSabaqDescAudio ===
                                      "string"
                                      ? elementInArray?.subSabaqDescAudio.substring(
                                        elementInArray?.subSabaqDescAudio
                                          .length - 15,
                                        elementInArray?.subSabaqDescAudio
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="sabaqImagePath"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setAddNamaz({
                                        ...addNamaz,
                                        subSabaq: addNamaz.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                subSabaqDescAudio:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                                <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher And Student)(English)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.subSabaqDescAudioEnglish ===
                                      "string"
                                      ? elementInArray?.subSabaqDescAudioEnglish.substring(
                                        elementInArray?.subSabaqDescAudioEnglish
                                          .length - 15,
                                        elementInArray?.subSabaqDescAudioEnglish
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="sabaqImagePath"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setAddNamaz({
                                        ...addNamaz,
                                        subSabaq: addNamaz.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                subSabaqDescAudioEnglish:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                                <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher And Student)(Arabic)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.subSabaqDescAudioArabic ===
                                      "string"
                                      ? elementInArray?.subSabaqDescAudioArabic.substring(
                                        elementInArray?.subSabaqDescAudioArabic
                                          .length - 15,
                                        elementInArray?.subSabaqDescAudioArabic
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="sabaqImagePath"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setAddNamaz({
                                        ...addNamaz,
                                        subSabaq: addNamaz.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                subSabaqDescAudioArabic:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                            <div className="col-md-12 mb-3">
                              <Form.Label>
                                Sub Sabaq Description Audio(Teacher And Student)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImagePath"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setAddNamaz({
                                    ...addNamaz,
                                    subSabaq: addNamaz.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            subSabaqDescAudio:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                             <div className="col-md-12 mb-3">
                              <Form.Label>
                                Sub Sabaq Description Audio(Teacher And Student)(English)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImagePath"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setAddNamaz({
                                    ...addNamaz,
                                    subSabaq: addNamaz.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            subSabaqDescAudioEnglish:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                             <div className="col-md-12 mb-3">
                              <Form.Label>
                                Sub Sabaq Description Audio(Teacher And Student)(Arabic)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImagePath"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setAddNamaz({
                                    ...addNamaz,
                                    subSabaq: addNamaz.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            subSabaqDescAudioArabic:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                            </>
                          )}

                          {idEdit ? (
                            <>
                              <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.teacherDescAudioPath ===
                                      "string"
                                      ? elementInArray?.teacherDescAudioPath.substring(
                                        elementInArray?.teacherDescAudioPath
                                          .length - 15,
                                        elementInArray?.teacherDescAudioPath
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="sabaqImagePath"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setAddNamaz({
                                        ...addNamaz,
                                        subSabaq: addNamaz.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                teacherDescAudioPath:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                               <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher)(English)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.subSabaqDescTeacherAudioEnglish ===
                                      "string"
                                      ? elementInArray?.subSabaqDescTeacherAudioEnglish.substring(
                                        elementInArray?.subSabaqDescTeacherAudioEnglish
                                          .length - 15,
                                        elementInArray?.subSabaqDescTeacherAudioEnglish
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="sabaqImagePath"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setAddNamaz({
                                        ...addNamaz,
                                        subSabaq: addNamaz.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                subSabaqDescTeacherAudioEnglish:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                               <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                    Sub Sabaq Description Audio(Teacher)(Arabic)
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.subSabaqDescTeacherAudioArabic ===
                                      "string"
                                      ? elementInArray?.subSabaqDescTeacherAudioArabic.substring(
                                        elementInArray?.subSabaqDescTeacherAudioArabic
                                          .length - 15,
                                        elementInArray?.subSabaqDescTeacherAudioArabic
                                          .length
                                      )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="sabaqImagePath"
                                    style={{ width: imageWidth.Description }}
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setAddNamaz({
                                        ...addNamaz,
                                        subSabaq: addNamaz.subSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                ...item,
                                                subSabaqDescTeacherAudioArabic:
                                                  e.target.files[0],
                                              }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                            <div className="col-md-12 mb-3">
                              <Form.Label>
                                Sub Sabaq Description Audio(Teacher)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImagePath"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setAddNamaz({
                                    ...addNamaz,
                                    subSabaq: addNamaz.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            teacherDescAudioPath:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                              <div className="col-md-12 mb-3">
                              <Form.Label>
                                Sub Sabaq Description Audio(Teacher)(English)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImagePath"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setAddNamaz({
                                    ...addNamaz,
                                    subSabaq: addNamaz.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            subSabaqDescTeacherAudioEnglish:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                              <div className="col-md-12 mb-3">
                              <Form.Label>
                                Sub Sabaq Description Audio(Teacher)(Arabic)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImagePath"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setAddNamaz({
                                    ...addNamaz,
                                    subSabaq: addNamaz.subSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                            ...item,
                                            subSabaqDescTeacherAudioArabic:
                                              e.target.files[0],
                                          }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                            </>
                          )}
                        </>
                      </div>
                      <div className="text-end">
                        <Link
                          to="#"
                          // className="btn btn-danger" onClick={() => setAddNewGroup(AddNewGroup - 1)}
                          className={
                            addNamaz.subSabaq.length > 1
                              ? "btn btn-danger"
                              : "btn btn-secondary invisible"
                          }
                          onClick={() => {
                            if (addNamaz.subSabaq.length > 1) {
                              // addNamaz.subSabaq.splice(index, 1);
                              const copySubDeatails = [...addNamaz.subSabaq];
                              copySubDeatails.splice(index, 1);
                              setAddNamaz({
                                ...addNamaz,
                                subSabaq: copySubDeatails,
                              });
                            }


                          }}
                        >
                          Remove
                        </Link>
                      </div>
                    </div>
                  );
                })}

              <Link
                to="#"
                className={
                  // idEdit
                  //   ? "add-newSabaq-btn invisible btn btn-secondary pe-none"
                  //   :
                  "add-newSabaq-btn btn btn-primary"
                }
                // onClick={() => setAddNewGroup(AddNewGroup + 1)}
                onClick={() => {
                  let namaz = [
                    ...addNamaz.subSabaq,

                    {
                      subSabaqTitle: "",
                      subSabaqTitleEnglish:"",
                      subSabaqTitleHindi:"",
                      subSabaqTitleUrdu:"",
                      subSabaqTitleArabic:"",
                      subSabaqTitleAudio: "",
                      subSabaqTitleAudioEnglish:"",
                      subSabaqTitleAudioArabic:"",
                      subSabaqDesc: "",
                      subSabaqDescEnglish:"",
                      subSabaqDescHindi:"",
                      subSabaqDescUrdu:"",
                      subSabaqDescArabic:"",
                      subSabaqDescAudio: "",
                      subSabaqDescAudioEnglish:"",
                      subSabaqDescAudioArabic:"",
                      titleTeacherAudioPath:"",
                      subSabaqTitleTeacherAudioEnglish:"",
                      subSabaqTitleTeacherAudioArabic:"",
                      teacherDescAudioPath:"",
                      subSabaqDescTeacherAudioEnglish:"",
                      subSabaqDescTeacherAudioArabic:"",
                      teacherTarjamaAudioPath:"",
                      teacherTarjamaAudioPathEnglish:"",
                      teacherTarjamaAudioPathArabic:"",
                      arabic: "",
                      arabicAudio: "",
                      tarjama: "",
                      tarjamaEnglish:"",
                      tarjamaHindi:"",
                      tarjamaUrdu:"",
                      tarjamaArabic:"",
                      tarjamaAudioPath: "",
                      tarjamaAudioPathEnglish:"",
                      tarjamaAudioPathArabic:"",
                      subSabaqDescReference: "",
                      subSabaqDescReferenceEnglsih:"",
                      subSabaqDescReferenceHindi:"",
                      subSabaqDescReferenceUrdu:"",
                      subSabaqDescReferenceArabic:"",
                    },
                  ];
                  setAddNamaz({
                    ...addNamaz,
                    subSabaq: namaz,
                  });
                }}
              >
                + Add Sub Sabaq Details
              </Link>
            </div>
            <div className="buttons-modal border-top pt-3 text-end ">
              <button className="me-2" type="submit" disabled={saveBotton}>
                {idEdit === "edit" ? "update" : "Save"}
              </button>
              <Link
                to="#"
                className=" bg-danger"
                onClick={() => {
                  setAddNamaz({
                    sabaqName: "",
                    sabaqEnglish:"",
                    sabaqHindi:"",
                    sabaqUrdu:"",
                    sabaqArabic:"",
                    sabaqDesc: "",
                    sabaqDescEnglish:"",
                    sabaqDescHindi:"",
                    sabaqDescUrdu:"",
                    sabaqDescArabic:"",
                    sabaqDescAudio: "",
                    sabaqDescAudioEnglish:"",
                    sabaqDescAudioArabic:"",
                    sabaqNameAudio: "",
                    sabaqNameAudioEnglish:"",
                    sabaqNameAudioArabic:"",
                    inArbic: "",
                    inArbicAudio: "",
                    subSabaqDescReference: "",
                    subSabaqDescReferenceEnglsih:"",
                    subSabaqDescReferenceHindi:"",
                    subSabaqDescReferenceUrdu:"",
                    subSabaqDescReferenceArabic:"",
                    tarjama: "",
                    tarjamaEnglish:"",
                    tarjamaHindi:"",
                    tarjamaUrdu:"",
                    tarjamaArabic:"",
                    tarjamaAudio: "",
                    sabaqDesc: "",
                    sabaqDescEnglish:"",
                    sabaqDescHindi:"",
                    sabaqDescUrdu:"",
                    sabaqDescArabic:"",
                    sabaqDescAudio: "",
                    sabaqDescAudioEnglish:"",
                    sabaqDescAudioArabic:"",
                    subSabaq: [
                      {
                        subSabaqTitle: "",
                        subSabaqTitleEnglish:"",
                        subSabaqTitleHindi:"",
                        subSabaqTitleUrdu:"",
                        subSabaqTitleArabic:"",
                        subSabaqTitleAudio: "",
                        subSabaqTitleAudioEnglish:"",
                        subSabaqTitleAudioArabic:"",
                        subSabaqDesc: "",
                        subSabaqDescEnglish:"",
                        subSabaqDescHindi:"",
                        subSabaqDescUrdu:"",
                        subSabaqDescArabic:"",
                        subSabaqDescAudio: "",
                        subSabaqDescAudioEnglish:"",
                        subSabaqDescAudioArabic:"",
                        arabic: "",
                        arabicAudio: "",
                        tarjama: "",
                        tarjamaEnglish:"",
                        tarjamaHindi:"",
                        tarjamaUrdu:"",
                        tarjamaArabic :"",
                        tarjamaAudioPath: "",
                        tarjamaAudioPathEnglish:"",
                        tarjamaAudioPathArabic:"",
                        subSabaqDescReference: "",
                        subSabaqDescReferenceEnglsih:"",
                        subSabaqDescReferenceHindi:"",
                        subSabaqDescReferenceUrdu:"",
                        subSabaqDescReferenceArabic:"",
                      },
                    ],
                  });
                  handleAddClose();
                  setIdEdit("");
                }}
              >
                Cancel
              </Link>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* ======================= END ADD ========================== */}

      {/* ======================= DELETE ========================== */}

      <Modal
        show={deleteModal}
        onHide={handleDeleteClose}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-msg text-center">
            <label htmlFor="">Are you sure you want to delete this item?</label>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <div className="buttons-modal    ">
            <button
              className="me-2 bg-danger"
              type="submit"
              onClick={() => {
                handleDeleteClose()
                namazLisDeleteApi()
              }}

            >
              Delete
            </button>
            <Link to="#" className="" onClick={handleDeleteClose}>
              Cancel
            </Link>
          </div>
        </Modal.Footer>
      </Modal>
      {/* ======================= END DELETE ========================== */}

      {/* ======================= VIEW ========================== */}
      <Modal
        show={viewModal}
        onHide={handleViewClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Namaaz Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="row">
              <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq No.
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.SabaqNo}
                  </label>
                </div>
              </div>

              {/* sabaqIcon */}
              <div className="col-md-6 mb-3">
                {/* <div>
                  <label htmlFor="" className="key">
                    Sabaq Icon
                  </label>
                </div>
                <div>
                  <MDBRow>
                    <MDBCol lg="2" md="3" className="mb-4">
                      <img
                        src={
                          !viewDetails?.sabaqIcon
                            ? ""
                            : ApiConfig.FILE_BASE_URL +
                              viewDetails?.sabaqIcon.length
                            ? ApiConfig.FILE_BASE_URL + viewDetails?.sabaqIcon
                            : ApiConfig.FILE_BASE_URL +
                                viewDetails?.sabaqIcon &&
                              URL.createObjectURL(
                                ApiConfig.FILE_BASE_URL + viewDetails?.sabaqIcon
                              )
                        }
                        className="img-fluid rounded value"
                        alt=""
                      />
                    </MDBCol>
                  </MDBRow>
                </div> */}
              </div>
              <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Name
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqName}
                  </label>
                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Name(English)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqEnglish}
                  </label>
                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Name(Hindi)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqHindi}
                  </label>
                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Name(Urdu)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqUrdu}
                  </label>
                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Name(Arabic)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqArabic}
                  </label>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher And Student)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqAudio ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails?.sabaqAudio}`} type="audio/ogg" />
                      <source src={`${FILE_BASE_URL}${viewDetails?.sabaqAudio}`} type="audio/mpeg" />
                    </audio>
                  ) : (
                    ""
                  )}

                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher And Student)(English)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqNameAudioEnglish ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails?.sabaqNameAudioEnglish}`} type="audio/ogg" />
                      <source src={`${FILE_BASE_URL}${viewDetails?.sabaqNameAudioEnglish}`} type="audio/mpeg" />
                    </audio>
                  ) : (
                    ""
                  )}

                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher And Student)(Arabic)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqNameAudioArabic ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails?.sabaqNameAudioArabic}`} type="audio/ogg" />
                      <source src={`${FILE_BASE_URL}${viewDetails?.sabaqNameAudioArabic}`} type="audio/mpeg" />
                    </audio>
                  ) : (
                    ""
                  )}

                </div>
              </div>
              <div className="col-md-6 mb-3"></div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqTeacherAudio ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails?.sabaqTeacherAudio}`} type="audio/ogg" />
                      <source src={`${FILE_BASE_URL}${viewDetails?.sabaqTeacherAudio}`} type="audio/mpeg" />
                    </audio>
                  ) : (
                    ""
                  )}

                </div>
              </div>
               <div className="col-md-6 mb-3"></div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher)(English)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqNameTeacherAudioEnglish ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails?.sabaqNameTeacherAudioEnglish}`} type="audio/ogg" />
                      <source src={`${FILE_BASE_URL}${viewDetails?.sabaqNameTeacherAudioEnglish}`} type="audio/mpeg" />
                    </audio>
                  ) : (
                    ""
                  )}

                </div>
              </div>
               <div className="col-md-6 mb-3"></div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio(Teacher)(Arabic)
                  </label>
                </div>
                <div>
                  {viewDetails?.sabaqNameTeacherAudioArabic ? (
                    <audio controls style={{ width: "100%", height: "38px" }}>
                      <source src={`${FILE_BASE_URL}${viewDetails?.sabaqNameTeacherAudioArabic}`} type="audio/ogg" />
                      <source src={`${FILE_BASE_URL}${viewDetails?.sabaqNameTeacherAudioArabic}`} type="audio/mpeg" />
                    </audio>
                  ) : (
                    ""
                  )}

                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq  Description
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDesc}
                  </label>
                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq  Description(English)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescEnglish}
                  </label>
                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq  Description(Hindi)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescHindi}
                  </label>
                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq  Description(Urdu)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescUrdu}
                  </label>
                </div>
              </div>
                <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq  Description(Arabic)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescArabic}
                  </label>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq  Description Audio(Teacher And Student)
                  </label>
                </div>
                <div>
                  {
                    viewDetails?.sabaqDescAudio ? (
                      <audio controls style={{ width: "100%", height: "38px" }}>
                        <source
                          src={`${FILE_BASE_URL}${viewDetails?.sabaqDescAudio}`}
                          type="audio/ogg"
                        />
                        <source
                          src={`${FILE_BASE_URL}${viewDetails?.sabaqDescAudio}`}
                          type="audio/mpeg"
                        />
                      </audio>
                    ) : (
                      ""

                    )
                  }

                </div>
              </div>
              <div className="col-md-6 mb-3"></div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq  Description Audio(Teacher And Student)(English)
                  </label>
                </div>
                <div>
                  {
                    viewDetails?.sabaqDescAudioEnglish ? (
                      <audio controls style={{ width: "100%", height: "38px" }}>
                        <source
                          src={`${FILE_BASE_URL}${viewDetails?.sabaqDescAudioEnglish}`}
                          type="audio/ogg"
                        />
                        <source
                          src={`${FILE_BASE_URL}${viewDetails?.sabaqDescAudioEnglish}`}
                          type="audio/mpeg"
                        />
                      </audio>
                    ) : (
                      ""

                    )
                  }

                </div>
              </div>
              <div className="col-md-6 mb-3"></div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq  Description Audio(Teacher And Student)(Arabic)
                  </label>
                </div>
                <div>
                  {
                    viewDetails?.sabaqDescAudioArabic ? (
                      <audio controls style={{ width: "100%", height: "38px" }}>
                        <source
                          src={`${FILE_BASE_URL}${viewDetails?.sabaqDescAudioArabic}`}
                          type="audio/ogg"
                        />
                        <source
                          src={`${FILE_BASE_URL}${viewDetails?.sabaqDescAudioArabic}`}
                          type="audio/mpeg"
                        />
                      </audio>
                    ) : (
                      ""

                    )
                  }

                </div>
              </div>
              <div className="col-md-6 mb-3"></div>
                              <div className="col-md-6 mb-3">
                                <div className="mb-2">
                                  <label htmlFor="" className="key">
                                    Sabaq Description Audio(Teacher)
                                  </label>
                                </div>
                                <div>
                                  {/* sabaqDescAudio */}
                                  {viewDetails?.sabaqTeacherDesc ? (
                                    <audio controls style={{ width: "100%", height: "38px" }}>
                                      <source
                                        src={`${FILE_BASE_URL}${viewDetails?.sabaqTeacherDesc}`}
                                        type="audio/ogg"
                                      />
                                      <source
                                        src={`${FILE_BASE_URL}${viewDetails?.sabaqTeacherDesc}`}
                                        type="audio/mpeg"
                                      />
                                      Your browser does not support the audio element.
                                    </audio>
                                  ) : (
                                    ""
                                  )}
              
                                </div>
                              </div>
              <div className="col-md-6 mb-3"></div>
                              <div className="col-md-6 mb-3">
                                <div className="mb-2">
                                  <label htmlFor="" className="key">
                                    Sabaq Description Audio(Teacher)(English)
                                  </label>
                                </div>
                                <div>
                                  {/* sabaqDescAudio */}
                                  {viewDetails?.sabaqDescTeacherAudioEnglish ? (
                                    <audio controls style={{ width: "100%", height: "38px" }}>
                                      <source
                                        src={`${FILE_BASE_URL}${viewDetails?.sabaqDescTeacherAudioEnglish}`}
                                        type="audio/ogg"
                                      />
                                      <source
                                        src={`${FILE_BASE_URL}${viewDetails?.sabaqDescTeacherAudioEnglish}`}
                                        type="audio/mpeg"
                                      />
                                      Your browser does not support the audio element.
                                    </audio>
                                  ) : (
                                    ""
                                  )}
              
                                </div>
                              </div>
              <div className="col-md-6 mb-3"></div>
                              <div className="col-md-6 mb-3">
                                <div className="mb-2">
                                  <label htmlFor="" className="key">
                                    Sabaq Description Audio(Teacher)(Arabic)
                                  </label>
                                </div>
                                <div>
                                  {/* sabaqDescAudio */}
                                  {viewDetails?.sabaqDescTeacherAudioArabic ? (
                                    <audio controls style={{ width: "100%", height: "38px" }}>
                                      <source
                                        src={`${FILE_BASE_URL}${viewDetails?.sabaqDescTeacherAudioArabic}`}
                                        type="audio/ogg"
                                      />
                                      <source
                                        src={`${FILE_BASE_URL}${viewDetails?.sabaqDescTeacherAudioArabic}`}
                                        type="audio/mpeg"
                                      />
                                      Your browser does not support the audio element.
                                    </audio>
                                  ) : (
                                    ""
                                  )}
              
                                </div>
                              </div>                                
              <div className="col-md-12 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq  Reference
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescReference}
                  </label>
                </div>
              </div>
               <div className="col-md-12 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq  Reference(English)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescReferenceEnglish}
                  </label>
                </div>
              </div>
               <div className="col-md-12 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq  Reference(Hindi)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescReferenceHindi}
                  </label>
                </div>
              </div>
               <div className="col-md-12 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq  Reference(Urdu)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescReferenceUrdu}
                  </label>
                </div>
              </div>
               <div className="col-md-12 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq  Reference(Arabic)
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.sabaqDescReferenceArabic}
                  </label>
                </div>
              </div>
              <h5 className="fw-bold">Sub Sabaq Details</h5>

              {viewDetails &&
                viewDetails.subSabaqs &&
                viewDetails.subSabaqs.map((ele, index) => {
                  return (
                    <div className="sub-group-main row" key={"keyle" + index}>
                      <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq  Title {ele.subSabaqNo}
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqTitle}
                          </label>
                        </div>
                      </div>
                        <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq  Title(English) {ele.subSabaqTitleEnglish}
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqTitleEnglish}
                          </label>
                        </div>
                      </div>
                        <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq  Title(Hindi){ele.subSabaqTitleHindi}
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqTitleHindi}
                          </label>
                        </div>
                      </div>
                        <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq  Title(Urdu){ele.subSabaqTitleUrdu}
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqTitleUrdu}
                          </label>
                        </div>
                      </div>
                        <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq  Title(Arabic){ele.subSabaqTitleArabic}
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele.subSabaqTitleArabic}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Title Audio(Teacher And Student)
                          </label>
                        </div>
                        <div>
                          {ele.titleAudioPath ? (
                            <audio controls style={{ width: "100%", height: "38px" }}>
                              <source src={`${FILE_BASE_URL}${ele.titleAudioPath}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.titleAudioPath}`} type="audio/mpeg" />
                              Your browser does not support the audio element.
                            </audio>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Title Audio(Teacher And Student)(English)
                          </label>
                        </div>
                        <div>
                          {ele.subSabaqTitleAudioEnglish ? (
                            <audio controls style={{ width: "100%", height: "38px" }}>
                              <source src={`${FILE_BASE_URL}${ele.subSabaqTitleAudioEnglish}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.subSabaqTitleAudioEnglish}`} type="audio/mpeg" />
                              Your browser does not support the audio element.
                            </audio>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Title Audio(Teacher And Student)(Arabic)
                          </label>
                        </div>
                        <div>
                          {ele.subSabaqTitleAudioArabic ? (
                            <audio controls style={{ width: "100%", height: "38px" }}>
                              <source src={`${FILE_BASE_URL}${ele.subSabaqTitleAudioArabic}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.subSabaqTitleAudioArabic}`} type="audio/mpeg" />
                              Your browser does not support the audio element.
                            </audio>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Title Audio(Teacher)
                          </label>
                        </div>
                        <div>
                          {ele.titleTeacherAudioPath ? (
                            <audio controls style={{ width: "100%", height: "38px" }}>
                              <source src={`${FILE_BASE_URL}${ele.titleTeacherAudioPath}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.titleTeacherAudioPath}`} type="audio/mpeg" />
                              Your browser does not support the audio element.
                            </audio>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Title Audio(Teacher)(English)
                          </label>
                        </div>
                        <div>
                          {ele.subSabaqTitleTeacherAudioEnglish ? (
                            <audio controls style={{ width: "100%", height: "38px" }}>
                              <source src={`${FILE_BASE_URL}${ele.subSabaqTitleTeacherAudioEnglish}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.subSabaqTitleTeacherAudioEnglish}`} type="audio/mpeg" />
                              Your browser does not support the audio element.
                            </audio>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                       <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Title Audio(Teacher)(Arabic)
                          </label>
                        </div>
                        <div>
                          {ele.subSabaqTitleTeacherAudioArabic ? (
                            <audio controls style={{ width: "100%", height: "38px" }}>
                              <source src={`${FILE_BASE_URL}${ele.subSabaqTitleTeacherAudioArabic}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.subSabaqTitleTeacherAudioArabic}`} type="audio/mpeg" />
                              Your browser does not support the audio element.
                            </audio>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      
                      
                      <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Tarjama
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value" style={{ maxWidth: "100%", overflowY: "hidden" }}>
                            {ele?.tarjama}
                          </label>
                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Tarjama(English)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value" style={{ maxWidth: "100%", overflowY: "hidden" }}>
                            {ele?.tarjamaEnglish}
                          </label>
                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Tarjama(Hindi)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value" style={{ maxWidth: "100%", overflowY: "hidden" }}>
                            {ele?.tarjamaHindi}
                          </label>
                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Tarjama(Urdu)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value" style={{ maxWidth: "100%", overflowY: "hidden" }}>
                            {ele?.tarjamaUrdu}
                          </label>
                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Tarjama(Arabic)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value" style={{ maxWidth: "100%", overflowY: "hidden" }}>
                            {ele?.tarjamaArabic}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Tarjama Audio(Teacher And Student)
                          </label>
                        </div>
                        <div>
                          {ele?.tarjamaAudioPath ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source
                                src={`${FILE_BASE_URL}${ele?.tarjamaAudioPath}`}
                                type="audio/ogg"
                              />
                              <source
                                src={`${FILE_BASE_URL}${ele?.tarjamaAudioPath}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : (
                            ""
                          )}

                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Tarjama Audio(Teacher And Student)(English)
                          </label>
                        </div>
                        <div>
                          {ele?.tarjamaAudioPathEnglish ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source
                                src={`${FILE_BASE_URL}${ele?.tarjamaAudioPathEnglish}`}
                                type="audio/ogg"
                              />
                              <source
                                src={`${FILE_BASE_URL}${ele?.tarjamaAudioPathEnglish}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : (
                            ""
                          )}

                        </div>
                      </div>
                       <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Tarjama Audio(Teacher And Student)(Arabic)
                          </label>
                        </div>
                        <div>
                          {ele?.tarjamaAudioPathArabic ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source
                                src={`${FILE_BASE_URL}${ele?.tarjamaAudioPathArabic}`}
                                type="audio/ogg"
                              />
                              <source
                                src={`${FILE_BASE_URL}${ele?.tarjamaAudioPathArabic}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : (
                            ""
                          )}

                        </div>
                      </div>
                      <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Tarjama Audio(Teacher)
                          </label>
                        </div>
                        <div>
                          {ele?.teacherTarjamaAudioPath ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source
                                src={`${FILE_BASE_URL}${ele?.teacherTarjamaAudioPath}`}
                                type="audio/ogg"
                              />
                              <source
                                src={`${FILE_BASE_URL}${ele?.teacherTarjamaAudioPath}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : (
                            ""
                          )}

                        </div>
                      </div>
                       <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Tarjama Audio(Teacher)(English)
                          </label>
                        </div>
                        <div>
                          {ele?.teacherTarjamaAudioPathEnglish ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source
                                src={`${FILE_BASE_URL}${ele?.teacherTarjamaAudioPathEnglish}`}
                                type="audio/ogg"
                              />
                              <source
                                src={`${FILE_BASE_URL}${ele?.teacherTarjamaAudioPathEnglish}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : (
                            ""
                          )}

                        </div>
                      </div>
                       <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Tarjama Audio(Teacher)(Arabic)
                          </label>
                        </div>
                        <div>
                          {ele?.teacherTarjamaAudioPathArabic ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source
                                src={`${FILE_BASE_URL}${ele?.teacherTarjamaAudioPathArabic}`}
                                type="audio/ogg"
                              />
                              <source
                                src={`${FILE_BASE_URL}${ele?.teacherTarjamaAudioPathArabic}`}
                                type="audio/mpeg"
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : (
                            ""
                          )}

                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Description
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele?.subSabaqDesc}
                          </label>
                        </div>
                      </div>
                         <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Description(English)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele?.subSabaqDescEnglish}
                          </label>
                        </div>
                      </div>
                         <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Description(Hindi)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele?.subSabaqDescHindi}
                          </label>
                        </div>
                      </div>
                         <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Description(Urdu)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele?.subSabaqDescUrdu}
                          </label>
                        </div>
                      </div>
                         <div className="col-md-6 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Description(Arabic)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele?.subSabaqDescArabic}
                          </label>
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Description Audio(Teacher And Student)
                          </label>
                        </div>
                        <div>
                          {ele?.descAudioPath ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.descAudioPath}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.descAudioPath}`} type="audio/mpeg" />
                            </audio>
                          ) : (
                            ""
                          )}

                        </div>
                      </div>
                        <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Description Audio(Teacher And Student)(English)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqDescAudioEnglish ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.subSabaqDescAudioEnglish}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.subSabaqDescAudioEnglish}`} type="audio/mpeg" />
                            </audio>
                          ) : (
                            ""
                          )}

                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Description Audio(Teacher And Student)(Arabic)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqDescAudioArabic ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.subSabaqDescAudioArabic}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.subSabaqDescAudioArabic}`} type="audio/mpeg" />
                            </audio>
                          ) : (
                            ""
                          )}

                        </div>
                      </div>
                      <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Description Audio(Teacher)
                          </label>
                        </div>
                        <div>
                          {ele?.teacherDescAudioPath ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.teacherDescAudioPath}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.teacherDescAudioPath}`} type="audio/mpeg" />
                            </audio>
                          ) : (
                            ""
                          )}

                        </div>
                      </div>
                      <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Description Audio(Teacher)(English)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqDescTeacherAudioEnglish ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.subSabaqDescTeacherAudioEnglish}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.subSabaqDescTeacherAudioEnglish}`} type="audio/mpeg" />
                            </audio>
                          ) : (
                            ""
                          )}

                        </div>
                      </div>
                       <div className="col-md-6 mb-3"></div>
                      <div className="col-md-6 mb-3">
                        <div className="mb-2">
                          <label htmlFor="" className="key">
                            Sub Sabaq Description Audio(Teacher)(Arabic)
                          </label>
                        </div>
                        <div>
                          {ele?.subSabaqDescTeacherAudioArabic ? (
                            <audio
                              controls
                              style={{ width: "100%", height: "38px" }}
                            >
                              <source src={`${FILE_BASE_URL}${ele.subSabaqDescTeacherAudioArabic}`} type="audio/ogg" />
                              <source src={`${FILE_BASE_URL}${ele.subSabaqDescTeacherAudioArabic}`} type="audio/mpeg" />
                            </audio>
                          ) : (
                            ""
                          )}

                        </div>
                      </div>
                      <div className="col-md-12 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Reference
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele?.subSabaqDescReference}
                          </label>
                        </div>
                      </div>
                        <div className="col-md-12 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Reference(English)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele?.subSabaqDescReferenceEnglsih}
                          </label>
                        </div>
                      </div>
                        <div className="col-md-12 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Reference(Hindi)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele?.subSabaqDescReferenceHindi}
                          </label>
                        </div>
                      </div>
                        <div className="col-md-12 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Reference(Urdu)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele?.subSabaqDescReferenceUrdu}
                          </label>
                        </div>
                      </div>
                        <div className="col-md-12 mb-3">
                        <div>
                          <label htmlFor="" className="key">
                            Sub Sabaq Reference(Arabic)
                          </label>
                        </div>
                        <div>
                          <label htmlFor="" className="value">
                            {ele?.subSabaqDescReferenceArabic}
                          </label>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="buttons-modal border-top pt-3 text-end ">
              <Link to="#" className="bg-danger" onClick={handleViewClose}>
                Cancel
              </Link>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* ======================= END VIEW ========================== */}
      {loader ? (
        <FormLoader />
      ) : (
        <div className="table-wrapper">
          <h6>Total Records : {namazList.length}</h6>
          <Table className="display" striped bordered hover size="lg">
            <thead className="text-center">
              <tr>
                <th>Sabaq No.</th>
                <th
                // style={{ textAlign: "left" }}
                >Sabaq List</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {namazList && namazList.length > 0
                ? namazList.slice(startIndex, endIndex).map((ele, index) => {
                  return (
                    <tr key={"newsr" + index}>
                      <td>{index + 1 + startIndex}</td>

                      <td style={{ textAlign: "left" }}>{ele.sabaqName}</td>
                      <td className="action">
                        <Link
                          to="#"
                          className="icon edit"
                          onClick={() => {
                            // handleAddShow();
                            setIdEdit("edit");
                            setImageWidth({
                              ...imageWidth,
                              sabaqAudio: "117px",
                              Uploade: "117px",
                              tarjamaAudio: "117px",
                              Description: "117px",
                              subSabaqTitle: "117px",
                              arabicAudio: "117px",
                            });
                            EditListApi(ele.sabaqId);
                          }}
                        >
                          <img src={ic_edit} alt="" />
                        </Link>
                        <Link
                          to="#"
                          className="icon view"
                          onClick={() => viewDetailshandle(ele.sabaqId)}
                        >
                          <img src={ic_eyes} alt="" />
                        </Link>
                        <Link
                          to="#"
                          className="icon delete"
                          onClick={() => {
                            handleDeleteShow();
                            setDeleteId(ele.sabaqId);
                          }}
                        >
                          <img src={ic_delete} alt="" />
                        </Link>
                      </td>
                    </tr>
                  );
                })
                : ""}
            </tbody>
          </Table>
          {namazList && namazList.length > 0 ? (
            <Pagination
              changePage={changePage}
              pageCount={pageCount}
              currentPage={currentPage}
            />
          ) : (
            <div>
              <h5 style={{ color: "red", textAlign: "center" }}>
                {" "}
                Records Not Found
              </h5>
            </div>
          )}
        </div>
      )}
    </main>
  );
};

export default Namaaz;
